import { Directive, Input, ElementRef, OnInit } from "@angular/core"
import { Node, ForceDirectedGraph } from "../models"
import { D3Service } from "../d3.service"

// TODO REMOVE WORDCLOUD
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "[draggableNode]",
})
export class DraggableDirective implements OnInit {
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("draggableNode") draggableNode: Node
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("draggableInGraph") draggableInGraph: ForceDirectedGraph

    constructor(private d3Service: D3Service, private _element: ElementRef) {}

    ngOnInit() {
        this.d3Service.applyDraggableBehaviour(
            this._element.nativeElement,
            this.draggableNode,
            this.draggableInGraph
        )
    }
}
